import React from 'react';
import { AvatarProps } from '@/types';

const Avatar: React.FC<AvatarProps> = ({ name = 'User', src: _src, size = 'md', online = false, className = '' }) => {
  const sizes = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-14 h-14 text-lg',
    xl: 'w-20 h-20 text-2xl'
  };

  const onlineSizes = {
    sm: 'w-2.5 h-2.5',
    md: 'w-3 h-3',
    lg: 'w-3.5 h-3.5',
    xl: 'w-4 h-4'
  };

  const initials = name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const getGradient = (text: string): string => {
    const gradients = [
      'from-indigo-500 to-purple-600',
      'from-blue-500 to-cyan-600',
      'from-emerald-500 to-teal-600',
      'from-amber-500 to-orange-600',
      'from-rose-500 to-pink-600',
      'from-violet-500 to-fuchsia-600',
    ];
    const index = text.charCodeAt(0) % gradients.length;
    return gradients[index];
  };

  return (
    <div className={`relative inline-block ${className}`}>
      <div className={`${sizes[size]} rounded-full bg-gradient-to-br ${getGradient(name)} flex items-center justify-center text-white font-bold shadow-lg ring-2 ring-white dark:ring-slate-800`}>
        {initials}
      </div>
      {online && (
        <span className={`absolute bottom-0 right-0 ${onlineSizes[size]} bg-emerald-500 border-2 border-white dark:border-slate-900 rounded-full ring-2 ring-emerald-100 dark:ring-emerald-900`} />
      )}
    </div>
  );
};

export default Avatar;
